import Main2 from "../../pages/client/AllEquipments/PressureVessel";
import ManageStaff from "../../pages/admin/ManageStaff";

import MyTasks from "../../pages/staff/MyTasks2";

//---------project------------
import TankMain from "../../pages/client/AllEquipments/Tank/Main";
import MainProjects from "../../pages/client/Project/allProjectsPage";
import ProjectForm from "../../pages/client/Project/ProjectForm";
import EquipForm from "../../pages/client/Project/ProjectForm/EquipsForm";
import { AuthProtected } from "../AuthProtectedOutlet";
import { AdminProtected } from "../AdminProtectedOutlet";
// import AllTimesheets from "../../pages/admin/AllTimesheets";
import paths from "../../api/paths.api";
import ClientVendorsPage from "../../pages/admin/Panel/ClientVendorsPage";
import AdminPanel from "../../pages/admin/Panel";

export const adminProtectedRoutes = [
  {
    path: "/main_pv/:name/:rev",
    element: <Main2 />,
  },
  // {
  //   path: "/register",
  //   element: <StaffRegister />,
  // },
  // {
  //   path: "/allstaff",
  //   element: <ManageStaff />,
  // },
  {
    path: paths.adminPanel + "/:subPanel",
    element: <AdminPanel />,
  },
  {
    path: "/new-project",
    element: <ProjectForm />,
  },
  {
    path: "/project-equipments",
    element: <EquipForm />,
  },
  {
    path: paths.clientVendors,
    element: <ClientVendorsPage />,
  },
  {
    path: "",
    element: <AuthProtected />,
    children: [
      {
        path: "/mytasks",
        element: <MyTasks />,
      },
      {
        path: "",
        element: <AdminProtected />,
        children: [
          // {
          //   path: "/main_pv",
          //   element: <Main2 />,
          // },
          // {
          //   path: "/alltimesheets",
          //   element: <AllTimesheets />,
          // },
        ],
      },
    ],
  },
];
